import { render, staticRenderFns } from "./ClientAccountingForm.vue?vue&type=template&id=55904708&"
import script from "./ClientAccountingForm.vue?vue&type=script&lang=js&"
export * from "./ClientAccountingForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccountingForm.vue?vue&type=style&index=0&id=55904708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports